import PropTypes from 'prop-types'
import Head from 'next/head'
import { GlobalFooter, PageContainer } from '@pocket/web-ui'
import GlobalNav from 'connectors/global-nav/global-nav'
import { SocialMetaData } from 'components/social-meta-data/social-meta-data'
import { HreflangLinks } from 'components/hreflang-links/hreflang-links'

function mainLayout({
  metaData,
  children,
  title = 'Pocket',
  canonical,
  renderHreflangLinks,
  selectedNavLink,
  isFullWidthLayout,
  hasFooterColorBorder
}) {
  const renderSocialMeta = metaData?.description && metaData?.title

  return (
    <>
      <Head>
        <title>{title}</title>
        <link rel="icon" type="image/x-icon" href="/favicon.ico" />
        {canonical ? <link rel="canonical" href={canonical} /> : null}
        {renderHreflangLinks ? (
          <HreflangLinks
            url={metaData?.url}
            showCanonical={canonical === undefined}
          />
        ) : null}
        {renderSocialMeta ? <SocialMetaData {...metaData} /> : null}
      </Head>

      <GlobalNav selectedLink={selectedNavLink} />

      {isFullWidthLayout ? children : <PageContainer>{children}</PageContainer>}

      <GlobalFooter hasColorBorder={hasFooterColorBorder} />
    </>
  )
}

mainLayout.propTypes = {
  /**
   * The selected link is normally determined by the GlobalNav based on current
   * route, but if you need to hardcode it to a particular link you can pass
   * in that link key here. OR, if you don't want any link selected, you can
   * pass in `null`.
   */
  selectedNavLink: PropTypes.string,

  /**
   * Set to true if you want to include `hreflang` tags for supported languages. This
   * will generate a meta tag for each individual alternate language as well as a
   * `x-default` and `canonical` tag.
   */
  renderHreflangLinks: PropTypes.bool,

  /**
   * Set to true if you need to have full-width or custom width content, in which
   * case you intend to implement your own content container in between the
   * GlobalNav and GlobalFooter, or use <PageContainer> manually within your
   * page content.
   */
  isFullWidthLayout: PropTypes.bool,

  /**
   * Set to true if you want the Global footer to use a full-width colored border.
   */
  hasFooterColorBorder: PropTypes.bool
}

mainLayout.defaultProps = {
  selectedNavLink: undefined,
  renderHreflangLinks: false,
  isFullWidthLayout: false,
  hasFooterColorBorder: false
}

export default mainLayout
